import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';
import { colours } from '@shared/theme/colours';

import { styles } from './PenTool.styles';

export interface PenToolIconProps extends WithStyles<typeof styles> {
  color?: string;
}

const PenToolIconComponent: FC<PenToolIconProps> = ({ classes, color = colours.neutral[400] }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      classes={{ root: classes.root }}
    >
      <g clipPath="url(#clip0_889_17940)">
        <path
          d="M8.66683 3.9999L4.33471 4.86632C4.09271 4.91472 3.97171 4.93892 3.87318 4.99777C3.78607 5.04979 3.71198 5.12101 3.65656 5.206C3.59387 5.30214 3.56492 5.42209 3.50701 5.66199L1.3335 14.6666M1.3335 14.6666L10.3381 12.493C10.578 12.4351 10.6979 12.4062 10.7941 12.3435C10.879 12.2881 10.9503 12.214 11.0023 12.1269C11.0611 12.0283 11.0853 11.9073 11.1337 11.6654L12.0002 7.33323M1.3335 14.6666L6.39083 9.60923M13.9126 5.24565L10.7544 2.08748C10.4904 1.82347 10.3584 1.69146 10.2062 1.642C10.0723 1.5985 9.92805 1.5985 9.79415 1.642C9.64193 1.69146 9.50993 1.82347 9.24591 2.08748L8.75441 2.57899C8.4904 2.843 8.35839 2.975 8.30893 3.12722C8.26543 3.26112 8.26543 3.40535 8.30893 3.53924C8.35839 3.69146 8.4904 3.82347 8.75441 4.08748L11.9126 7.24565C12.1766 7.50966 12.3086 7.64167 12.4608 7.69113C12.5947 7.73463 12.7389 7.73463 12.8728 7.69113C13.0251 7.64167 13.1571 7.50966 13.4211 7.24565L13.9126 6.75415C14.1766 6.49014 14.3086 6.35813 14.3581 6.20591C14.4016 6.07201 14.4016 5.92778 14.3581 5.79389C14.3086 5.64167 14.1766 5.50966 13.9126 5.24565ZM7.3335 7.33323C8.06987 7.33323 8.66683 7.93019 8.66683 8.66657C8.66683 9.40295 8.06988 9.9999 7.3335 9.9999C6.59712 9.9999 6.00016 9.40295 6.00016 8.66657C6.00016 7.93019 6.59712 7.33323 7.3335 7.33323Z"
          stroke={color}
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_889_17940">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const PenToolIcon = withStyles(styles)(PenToolIconComponent);
